import { Form, Pagination } from 'react-bootstrap'

interface PaginationSectionProps {
  first: number
  setFirst: (n: number) => void
  currentPage: number
  totalPages: number
  start: number
  end: number
  totalPolicies: number
  updatePage: (n: number) => void
  PaginationUtils: any
  pageSizeOptions?: number[] // Opciones personalizables para tamano de pagina
}

export const PaginationSection: React.FC<PaginationSectionProps> = ({
  first,
  setFirst,
  currentPage,
  totalPages,
  start,
  end,
  totalPolicies,
  updatePage,
  PaginationUtils,
  pageSizeOptions = [10, 20, 30, 50], // Por defecto las opciones estandar
}) => (
  <div className='pagination-container table-pagination-top'>
    <div className='pagination-summary'>
      <div className='pagination-entries'>
        <span style={{flex: 0}}>Show</span>
        <Form.Select
          value={first}
          onChange={(e) => {
            setFirst(Number(e.target.value))
          }}
          style={{flex: 0, flexBasis: '80px'}}
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </Form.Select>
        <span style={{flex: 1}}> entries</span>
      </div>
      <div className='pagination-text'>
        Showing {start} to {end} of {totalPolicies} entries
      </div>
    </div>
    <div className='pagination-pages'>
      <Pagination size='sm'>
        <Pagination.Prev
          disabled={currentPage === 1}
          onClick={() => {
            if (currentPage > 1) updatePage(currentPage - 1)
          }}
        />
        <Pagination.Item
          active={currentPage === 1}
          onClick={() => {
            if (currentPage !== 1) updatePage(1)
          }}
        >
          1
        </Pagination.Item>
        {currentPage > 3 && <Pagination.Ellipsis disabled />}
        {PaginationUtils.getVisiblePages(currentPage, totalPages)
          .slice(1)
          .map((page) => (
            <Pagination.Item
              key={page}
              active={page === currentPage}
              onClick={() => {
                if (page !== currentPage) updatePage(page)
              }}
            >
              {page}
            </Pagination.Item>
          ))}
        {totalPages > 1 && currentPage < totalPages - 2 && <Pagination.Ellipsis disabled />}
        {totalPages > 1 && currentPage < totalPages - 1 && (
          <Pagination.Item
            active={currentPage === totalPages}
            onClick={() => {
              if (currentPage !== totalPages) updatePage(totalPages)
            }}
          >
            {totalPages}
          </Pagination.Item>
        )}
        <Pagination.Next
          disabled={currentPage === totalPages}
          onClick={() => {
            if (currentPage < totalPages) updatePage(currentPage + 1)
          }}
        />
      </Pagination>
    </div>
  </div>
)
